<!--
 * @Description: 快速检测
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-09-24 14:24:50
-->
<template>
  <CommonCheckout :dataTypeId='1'/>
</template>

<script>
import CommonCheckout from './commoncheckout'
export default {
  components: {
    CommonCheckout
  },
};
</script>
